import { getImage } from "../../config/imageConfig";

export function getHeaderContent() {
  return {
    "/": {
      title: "Carpe diem Bar, restaurant et chambres d'hôtes",
      subtitle: "",
      image:
        getImage("header.home") || "https://i.ibb.co/bgwCkjFv/resto-vinc.jpg",
    },
    "/loginMagVinc": {
      title: "Carpe diem Bar, restaurant et chambres d'hôtes",
      subtitle: "",
      image:
        getImage("header.home") || "https://i.ibb.co/bgwCkjFv/resto-vinc.jpg",
    },
    "/menu": {
      title: "Menu",
      subtitle:
        "Découvrez notre sélection de plats et boissons pour tous les goûts.",
      image: getImage("header.menu") || "https://i.ibb.co/4Zm9VF9k/menu.jpg",
    },
    "/restaurant-chambres": {
      title: "Le Restaurant et les Chambres",
      subtitle:
        "Passionnés et professionnels, découvrez notre magnifique restaurant et nos chambres cosy.",
      image:
        getImage("header.restaurantChambres") ||
        "https://i.ibb.co/9Hwtx1Vs/Salle-manger-de-jour.jpg",
    },
    "/notre-restaurant": {
      title: "Notre Restaurant",
      subtitle:
        "Découvrez notre univers culinaire et réservez votre table en quelques clics.",
      image:
        getImage("header.restaurantChambres") ||
        "https://i.ibb.co/9Hwtx1Vs/Salle-manger-de-jour.jpg",
    },
    "/nos-chambres": {
      title: "Nos Chambres",
      subtitle:
        "Découvrez nos chambres d'hôtes et réservez votre séjour facilement.",
      image:
        getImage("header.restaurantChambres") ||
        "https://i.ibb.co/9Hwtx1Vs/Salle-manger-de-jour.jpg",
    },
    "/reservation": {
      title: "Réservation",
      subtitle: "Réservez votre table ou votre chambre facilement en ligne.",
      image:
        getImage("header.reservation") || "https://i.ibb.co/jZk6brPV/resto.jpg",
    },
    "/reservation-restaurant": {
      title: "Réservation Restaurant",
      subtitle: "Réservez votre table facilement en ligne.",
      image:
        getImage("header.reservation") || "https://i.ibb.co/jZk6brPV/resto.jpg",
    },
    "/reservation-chambre": {
      title: "Réservation Chambre",
      subtitle: "Réservez votre chambre facilement en ligne.",
      image:
        getImage("header.reservation") || "https://i.ibb.co/jZk6brPV/resto.jpg",
    },
    "/evenements": {
      title: "Événements",
      subtitle: "Retrouvez tous les événements en cours et à venir.",
      image:
        getImage("header.events") || "https://i.ibb.co/bgwCkjFv/resto-vinc.jpg",
    },
    "/tourisme": {
      title: "Tourisme",
      subtitle:
        "Découvrez les activités et lieux touristiques autour du Carpe Diem.",
      image:
        getImage("header.tourism") ||
        "https://i.ibb.co/bgwCkjFv/resto-vinc.jpg",
    },
    "/allergenes": {
      title: "Allergènes",
      subtitle: "Consultez le tableau des allergènes de nos plats.",
      image:
        getImage("header.allergens") ||
        "https://i.ibb.co/bgwCkjFv/resto-vinc.jpg",
    },
    "/contact": {
      title: "Contact",
      subtitle: "Contactez-nous pour toute demande ou information.",
      image:
        getImage("header.contact") || "https://i.ibb.co/tTk44PJB/contact.png",
    },
  };
}
